/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import * as firebase from "firebase";

export type UserCredentials = firebase.auth.UserCredential;

export class AuthService {
    private _app: firebase.app.App;
    private _suApp: firebase.app.App = null;
    private _env = null;
    init(env) {
        this._env = env;
        if (!this._app) {
            this._app = firebase.initializeApp({
                projectId: env.FIREBASE_PROJECT_ID,
                apiKey: env.FIREBASE_API_KEY,
                authDomain: env.FIREBASE_AUTH_DOMAIN,
            });
        }
        if (!this._suApp) {
            this._suApp = firebase.initializeApp(
                {
                    projectId: this._env.FIREBASE_PROJECT_ID,
                    apiKey: this._env.FIREBASE_API_KEY,
                    authDomain: this._env.FIREBASE_AUTH_DOMAIN,
                },
                "secondary"
            );
        }
    }

    public async signIn(email, password) {
        const credentials = await this._app.auth().signInWithEmailAndPassword(email, password);
        return credentials;
    }

    public async signInWithCredential(userCredentials: firebase.auth.UserCredential) {
        const credentials = await this._app.auth().signInWithCredential(userCredentials.credential);
        return credentials;
    }

    public async signUp(email, password) {
        return this._app.auth().createUserWithEmailAndPassword(email, password);
    }

    public async suWithCustomToken(token) {
        return this._suApp.auth().signInWithCustomToken(token);
    }

    public async endSu() {
        await this._suApp.auth().signOut();

        const user = this._app.auth().currentUser;
        if (user) return user.getIdToken(true);
        return null;
    }

    public async signOut() {
        return this._app.auth().signOut();
    }

    public async sendPasswordResetEmail(email) {
        return this._app.auth().sendPasswordResetEmail(email);
    }

    public async changePassword(email: string, currentPassword: string, newPassword: string) {
        // Refresh current user / token
        const crendentials = await this.signIn(email, currentPassword);
        this._app.auth().currentUser.updatePassword(newPassword);
        return crendentials;
    }

    public async onRefreshToken(cb: (newToken: string) => void) {
        const refreshToken = async () => {
            const user = this._app.auth().currentUser;
            if (user) {
                const token = await user.getIdToken(true);
                cb(token);
            }
        };
        setTimeout(refreshToken, 5000); // TODO
        setInterval(refreshToken, 1800 * 1000); // 30 mins
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/services/Auth.service.ts